import {
  isAuth,
  isNotAuth,
  isGuest,
  isAdminAuth,
  invitationAccepted,
  checkTeamMember,
  checkClientRole,
} from "@/assets/helper/auth.helper";
import ConnectedApps from "../pages/fly/ConnectedApps.vue";
import Gallery from "../pages/fly/Gallery.vue";
import CreatePost from "../pages/fly/CreatePost.vue";
import SSOLogin from "../pages/SSOLogin.vue";
import CompleteSignup from "../pages/CompleteSignup.vue";
import SignUp from "../pages/SignUp.vue";
import UpdateGalleryImage from "../pages/fly/UpdateGalleryImage.vue";
import UpdateGalleryVideo from "../pages/fly/UpdateGalleryVideo.vue";
import ConnectionSuccess from "../pages/fly/ConnectionSuccess.vue";
import Posts from "../pages/fly/Posts.vue";
import ManageApiKey from "../pages/fly-api/ApiConfiguration.vue";
import Dashboard from "../pages/fly/Dashboard.vue";
import Error from "../pages/fly/ErrorComponent.vue";
import Account from "../pages/fly/Account";
import Teams from "../pages/fly/Teams.vue";
import AssignWorkspace from "../pages/fly/AssignTeamWorkspace.vue";
import PostPreview from "../pages/fly/PostPreview.vue";
import Contactus from "@/pages/fly/Contactus";
import UpdateProfile from "@/pages/fly/UpdateProfile";
import HelpCms from "@/pages/admin/HelpCms.vue";
import UpdateHelpCms from "@/pages/admin/UpdateHelpCms.vue";
import Terms from "@/pages/website/Terms";
import PrivacyPolicy from "@/pages/website/PrivacyPolicy";
import Subscription from "@/components/ui/Subscription.vue";
import SignupOffer from "@/components/ui/SignupOffer.vue";
import Help from "@/pages/fly//help/Help";
import Facbookhelp from "@/pages/fly/help/Facbookhelp";
import Instagramhelp from "@/pages/fly/help/Instagramhelp";
import Youtubehelp from "@/pages/fly/help/Youtubehelp";
import Twitterhelp from "@/pages/fly/help/Twitterhelp";
import UniversalFeed from "@/components/ui/UniversalFeed";
import Resources from "@/pages/fly/help/Resources.vue";
import AddCampaign from "../pages/fly/AddCampaign.vue";
import TwittterConnect from "@/pages/fly//help/TwittterConnect";
import CreateCarListings from "@/pages/fly/CreateCarListings.vue";
import Brandinfo from "@/pages/fly/Brandinfo.vue";
import ProductService from "@/pages/fly/ProductService";
import Createai from "@/pages/fly/Createai.vue";
import Suggestai from "@/pages/fly/Suggestai.vue";
import CustomTokenLogin from "@/pages/CustomTokenLogin.vue";
import Thanks from "@/pages/fly/Thanks.vue";
import Calender from "@/pages/fly/Calender.vue";
import Createsell from "@/pages/fly/Createsell.vue";
import EmailLogin from "@/pages/EmailLogin.vue";
import InvitationAccepted from "@/components/teamFeature/InvitaionAccepted.vue";
import AcceptInvitation from "@/components/teamFeature/AcceptInvitaion.vue";
import GenerateImage from "../pages/fly/GenerateImage.vue";
import ChooseTemplate from "@/pages/fly/ChooseTemplate.vue";
import store from "@/store";
import ContentFeed from "@/components/contentFeed/ContentFeed.vue";
import ContentAi from "@/components/contentAI/ContentAi.vue";
import ContentInsights from "@/pages/fly/ContentInsights.vue";
import FlyliteLogin from "../pages/FlyliteLogin.vue";
import FlyLite from "@/pages/fly-lite/FlyLite.vue";
import Location from "@/components/locations/Location.vue";
import StoreLocator from "@/components/locations/StoreLocator.vue";
import StoreInvitationAccepted from "@/components/locations/InvitationAccepted.vue";
import AcceptInvite from "@/components/locations/AcceptInvite.vue";
import GmbAnalytics from "@/pages/fly/GmbAnalytics.vue";
import UpdateGMBProfile from "@/pages/fly/UpdateGMBProfile.vue";
import GmbReviews from "@/pages/fly/GmbReviews.vue";
import GmbReviewsReport from "@/pages/fly/GMBReviewInsights.vue";
import ReviewTargetSetting from "@/pages/fly/ReviewTargetSetting.vue";
import PhotoTargetSetting from "@/pages/fly/PhotoTargetSetting.vue";
import EscalationToSetting from "@/pages/fly/EscalationToSetting.vue";
import GmbSearchReport from "@/pages/fly/GmbSearchReport.vue";
import GmbCompetitorAnalysis from "@/pages/fly/GmbCompetitorAnalysis.vue";
import GmbRPACompetitorAnalysis from "@/pages/fly/GmbRPACompetitorAnalysis.vue";
import GmbNoReviewLocations from "@/pages/fly/GmbNoReviewLocations.vue";
import Feedback from "@/pages/fly/NewFeedBack.vue";
import GmbOffer from "@/pages/fly/GmbLocationOffer.vue";
import GmbReviewDashboard from "@/pages/fly/GmbReviewManagement/GmbReviewLanding.vue";
import GenerateAccessToken from "@/pages/admin/GenerateAccessToken.vue";
import BusinessDetails from "@/pages/fly/business_details/BusinessDetails.vue";
import GMBRecommendations from "@/pages/fly/recommendations/GMBRecommendations.vue";
import GmbCompetitorAnalysisReport from "@/pages/fly/GmbCompetitorAnalysisReport.vue";
import AdminDashboard from "@/pages/admin/AdminDashboard.vue"
import OperationsDashboard from "@/pages/admin/OperationsDashboard.vue"
import GmbSeoAudit from "@/pages/fly/GmbSeoAudit.vue";
import CompetitorSummary from "@/pages/fly/CompetitorSummary.vue";
import StoreLocatorConfigurations from "@/pages/fly/StoreLocatorConfigurations.vue";
import IndividualStoreConfigurations from "@/pages/fly/IndividualStoreConfigurations.vue";
import BlogManagement from "@/pages/fly/BlogManagement.vue";
import BlogEditor from "@/pages/fly/BlogEditor.vue";
import Website from "@/pages/fly/Website.vue";
import ConnectSchedulePosts from "@/pages/fly/ConnectSchedulePosts.vue";
import OpsDashboard from "@/pages/fly/ops/OpsDashboard.vue";

import { onAuthStateChanged } from "firebase/auth";
import { auth } from "@/utils/firebase.utils";

let routes = [
  {
    path: "/home",
    // name: "home-page",
    // component: HomePage,

    redirect: { name: "calendar" },
    beforeEnter: isGuest,
  },

  {
    path: "/",
    redirect: (to) => {
      if (localStorage.getItem("lite") === "true") {
        return { path: "/lite" };
      } else {
        return { name: "calendar" };
      }
    },
    beforeEnter: isGuest,
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: Contactus,
    beforeEnter: isGuest,
  },
  {
    path: "/generate-access-token",
    name: "GenerateAccessToken",
    component: GenerateAccessToken,
    beforeEnter: isAuth,
  },
  {
    path: "/posts",
    name: "fly",
    component: Posts,
    beforeEnter: checkClientRole,
  },

  {
    path: "/api-key-gen",
    name: "generateflyApiKey",
    component: ManageApiKey,
    beforeEnter: isAuth,
  },

  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    beforeEnter: isAuth,
  },
  {
    path: "/performance",
    name: "performance",
    component: GmbAnalytics,
    beforeEnter: isAuth,
  },
  {
    path: "/local-rank-insights",
    name: "local-rank-insights",
    component: GmbCompetitorAnalysis,
    beforeEnter: isAuth,
  },
  {
    path: "/seo-audit",
    name: "seo-audit",
    component: GmbSeoAudit,
    beforeEnter: isAuth,
  },
  {
    path: "/competitor-analysis",
    name: "competitor-analysis",
    component: GmbCompetitorAnalysisReport,
    beforeEnter: isAuth,
  },
  {
    path: "/competitor-summary",
    name: "competitor-summary",
    component: CompetitorSummary,
    beforeEnter: isAuth,
  },
  {
    path: "/gmb-rpa-competitor-analysis",
    name: "gmb-rpa-competitor-analysis",
    component: GmbRPACompetitorAnalysis,
    beforeEnter: isAuth,
  },
  {
    path: "/gmb-reviews",
    name: "gmb-reviews",
    redirect: { name: "review-dashboard", query: { tab: "gmb-reviews" } },
    component: GmbReviews,
    beforeEnter: isAuth,
  },
  {
    path: "/gmb-reviews-report",
    name: "gmb-reviews-report",
    redirect: {
      name: "reviews",
      query: { tab: "gmb-reviews-report" },
    },
    component: GmbReviewsReport,
    beforeEnter: isAuth,
  },
  {
    path: "/review-target-setting",
    name: "review-target-setting",
    component: ReviewTargetSetting,
    beforeEnter: isAuth,
  },
  {
    path: "/photo-target-setting",
    name: "photo-target-setting",
    component: PhotoTargetSetting,
    beforeEnter: isAuth,
  },
  {
    path: "/escalation-to-setting",
    name: "escalation-to-setting",
    component: EscalationToSetting,
    beforeEnter: isAuth,
  },
  {
    path: "/gmb-no-locations",
    name: "gmb-no-locations",
    redirect: { name: "reviews", query: { tab: "gmb-no-locations" } },
    component: GmbNoReviewLocations,
    beforeEnter: isAuth,
  },
  {
    path: "/search-insights",
    name: "search-insights",
    component: GmbSearchReport,
    beforeEnter: isAuth,
  },

  {
    path: "/lite",
    name: "lite",
    component: FlyLite,
  },

  {
    path: "/feedback",
    name: "Feedback",
    component: Feedback,
    beforeEnter: isAuth,
  },

  {
    path: "/calendar",
    name: "calendar",
    component: Calender,
    beforeEnter: isAuth,
  },
  {
    path: "/reviews",
    name: "reviews",
    component: GmbReviewDashboard,
    beforeEnter: isAuth,
  },
  {
    path: "/locations",
    name: "locations",
    component: Location,
    beforeEnter: isAuth,
  },
  {
    path: "/accept-invite",
    name: "accept-invite",
    component: AcceptInvite,
  },
  {
    path: "/store-invitation-accepted",
    name: "store-invitation-accepted",
    component: StoreInvitationAccepted,
  },
  {
    path: "/content-insights",
    name: "content-insights",
    component: ContentInsights,
    beforeEnter: isAuth,
  },
  {
    path: "/brand-info",
    name: "brand-info",
    component: Brandinfo,
    beforeEnter: isAuth,
  },
  {
    path: "/brand",
    name: "brand",
    component: BusinessDetails,
    beforeEnter: isAuth,
  },
  {
    path: "/store-locator-configurations",
    name: "store-locator-configurations",
    component: StoreLocatorConfigurations,
    beforeEnter: isAuth,
  },
  {
    path: "/individual-store-configurations",
    name: "individual-store-configurations",
    component: IndividualStoreConfigurations,
    beforeEnter: isAuth,
  },
  {
    path: "/recommendations",
    name: "recommendations",
    component: GMBRecommendations,
    beforeEnter: isAuth,
  },
  {
    path: "/product-service-catalogue",
    name: "product-service-catalogue",
    component: ProductService,
    beforeEnter: isAuth,
  },
  {
    path: "/connect-schedule-posts",
    name: "connect-schedule-posts",
    component: ConnectSchedulePosts,
    beforeEnter: isGuest,
  },
  {
    path: "/create",
    name: "create",
    component: Createai,
    beforeEnter: checkClientRole,
  },
  {
    path: "/suggestai",
    name: "suggestai",
    component: Suggestai,
    beforeEnter: checkClientRole,
  },
  {
    path: "/content-ai",
    name: "contentai",
    component: ContentAi,
    beforeEnter: checkClientRole,
  },
  {
    path: "/edit-profile",
    name: "edit-profile",
    component: UpdateProfile,
    beforeEnter: isAuth,
  },
  {
    path: "/about-us",
    name: "AboutUs",
    component: Contactus,
    beforeEnter: isGuest,
  },
  {
    path: "/help",
    name: "Help",
    component: Help,
    beforeEnter: isGuest,
  },
  {
    path: "/help/facebook",
    name: "help/facebook",
    component: Facbookhelp,
    beforeEnter: isGuest,
  },
  {
    path: "/help/instagram",
    name: "help/instagram",
    component: Instagramhelp,
    beforeEnter: isGuest,
  },
  {
    path: "/help/youtube",
    name: "help/youtube",
    component: Youtubehelp,
    beforeEnter: isGuest,
  },
  {
    path: "/help/twitter",
    name: "help/twitter",
    component: Twitterhelp,
    beforeEnter: isGuest,
  },

  {
    path: "/login",
    name: "login",
    component: SSOLogin,
    beforeEnter: isNotAuth,
  },
  {
    path: "/login-phone",
    name: "login-phone",
    component: SSOLogin,
    beforeEnter: isNotAuth,
  },
  {
    path: "/login-email",
    name: "login-email",
    component: EmailLogin,
    beforeEnter: isNotAuth,
  },
  {
    path: "/subscription",
    name: "subscription",
    component: Subscription,
    beforeEnter: isAuth,
  },
  {
    path: "/suo",
    name: "suo",
    component: SignupOffer,
    beforeEnter: isAuth,
  },

  {
    path: "/terms-of-use",
    name: "terms-of-use",
    component: Terms,
    beforeEnter: isGuest,
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: PrivacyPolicy,
    beforeEnter: isGuest,
  },
  {
    path: "/complete-signup",
    name: "complete-signup",
    component: CompleteSignup,
    beforeEnter: isNotAuth,
  },
  {
    path: "/signup",
    name: "signup",
    component: SignUp,
    beforeEnter: isNotAuth,
  },
  {
    path: "/create-post",
    name: "create-post",
    component: CreatePost,
    beforeEnter: checkClientRole,
  },
  {
    path: "/repost/:postId",
    name: "repost",
    component: CreatePost,
    beforeEnter: checkClientRole,
    props: { isRepost: true },
  },
  {
    path: "/edit-post/:postId",
    name: "edit-post",
    component: CreatePost,
    beforeEnter: checkClientRole,
  },
  {
    path: "/draft-post/:postId",
    name: "draft-post",
    component: CreatePost,
    beforeEnter: checkClientRole,
  },
  {
    path: "/gallery",
    name: "gallery",
    component: Gallery,
    beforeEnter: checkClientRole,
  },
  {
    path: "/account",
    name: "account",
    component: Account,
    beforeEnter: isAuth,
  },
  {
    path: "/update-gallery-image/:id",
    name: "update-gallery-image",
    component: UpdateGalleryImage,
    beforeEnter: isAuth,
  },
  {
    path: "/update-gallery-video/:id",
    name: "update-gallery-video",
    component: UpdateGalleryVideo,
    beforeEnter: isAuth,
  },
  {
    path: "/connected-apps",
    name: "connected-apps",
    component: ConnectedApps,
    beforeEnter: isAuth,
  },
  {
    path: "/connection-success",
    name: "connection-success",
    component: ConnectionSuccess,
  },
  {
    path: "/error",
    name: "error",
    component: Error,
    props: (route) => ({
      error: route.query.error,
      stackTrace: route.query.stackTrace,
    }),
    beforeEnter: isGuest,
  },
  {
    path: "/team",
    name: "team",
    component: Teams,
    beforeEnter: isAuth,
  },
  {
    path: "/invitation-accepted",
    name: "InvitationAccepted",
    component: InvitationAccepted,
    beforeEnter: invitationAccepted,
  },
  {
    path: "/accept-invitation",
    name: "AcceptInvitation",
    component: AcceptInvitation,
    beforeEnter: isAuth,
  },
  {
    path: "/assign-workspace/:uid",
    name: "Assign-workspace",
    component: AssignWorkspace,
    beforeEnter: isAuth,
  },
  {
    path: "/content-feed",
    name: "contentfeed",
    component: ContentFeed,
    beforeEnter: checkClientRole,
  },
  {
    path: "/post/:uid/:wid/:id/",
    name: "post",
    component: PostPreview,
    beforeEnter: isAuth,
  },
  {
    path: "/power-users",
    name: "admin",
    component: AddCampaign,
    beforeEnter: isGuest,
  },

  {
    path: "/update-help-cms/:id",
    name: "update-help-cms",
    component: UpdateHelpCms,
    beforeEnter: isAdminAuth,
  },
  {
    path: "/universal-feed",
    name: "universal-feed",
    component: UniversalFeed,
    beforeEnter: isAuth,
  },
  {
    path: "/resources",
    name: "resources",
    component: Resources,
    beforeEnter: isGuest,
  },

  {
    path: "/power-users",
    name: "help-cms",
    component: HelpCms,
    beforeEnter: isAdminAuth,
  },

  {
    path: "/twitter-connect",
    name: "twitter-connect",
    component: TwittterConnect,
    beforeEnter: isAuth,
  },
  {
    path: "/create-car-listings",
    name: "create-car-listings",
    component: CreateCarListings,
    beforeEnter: checkClientRole,
  },
  {
    path: "/create-car-sell",
    name: "create-car-sell",
    component: Createsell,
    beforeEnter: checkClientRole,
  },
  {
    path: "/custom-token-login",
    name: "custom-token-login",
    component: CustomTokenLogin,
  },
  {
    path: "/choose-template/:id",
    name: "choose-template",
    component: ChooseTemplate,
  },
  {
    path: "/generate-image/:id",
    name: "generate-image",
    component: GenerateImage,
  },
  {
    path: "/profiles",
    name: "profiles",
    component: UpdateGMBProfile,
    beforeEnter: isAuth,
  },
  {
    path: "/offers",
    name: "offers",
    component: GmbOffer,
    beforeEnter: isAuth,
  },
  {
    path: "/swot",
    name: "swot",
    component: AdminDashboard,
    beforeEnter: isAdminAuth,
  },
  {
    path: "/dashboard-ops",
    name: "operations-dashboard",
    component: OperationsDashboard,
    beforeEnter: isAdminAuth,
  },
  {
    path: "/store-locator/:uid/:wid/:slug?",
    name: "store-locator",
    component: StoreLocator,
    props: (route) => ({
      embedUid: route.params.uid,
      embedWid: route.params.wid,
      embedSlug: route.params.slug,
    }),
    meta: { embed: true },
    // No auth guard for public embed
  },
  {
    path: "/location/:userUid/:wid/:locationId/:slug?/:tabvalue",
    name: "individual-store-tab",
    component: () => import("@/pages/fly/IndividualStore.vue"),
    props: (route) => ({
      userUid: route.params.userUid,
      wid: route.params.wid,
      locationId: route.params.locationId,
      slug: route.params.slug,
      tabvalue: route.params.tabvalue,
    }),
    meta: { public: true },
  },
  {
    path: "/location/:userUid/:wid/:locationId/:slug?",
    name: "individual-store",
    component: () => import("@/pages/fly/IndividualStore.vue"),
    props: (route) => ({
      userUid: route.params.userUid,
      wid: route.params.wid,
      locationId: route.params.locationId,
      slug: route.params.slug,
    }),
    meta: { public: true },
  },

  {
    path: "/footfall-insights",
    name: "footfall-insights",
    component: () => import("@/pages/fly/FootfallInsights.vue"),
    beforeEnter: isAuth,
    meta: {
      title: "Footfall Insights",
      menuGroup: "Track & Improve",
    },
  },
  {
    path: "/microsite",
    name: "microsite",
    component: Website,
    beforeEnter: isAuth,
    meta: {
      title: "Website Management",
      menuGroup: "Website",
    },
  },
  {
    path: "/blog-management",
    name: "blog-management",
    component: BlogManagement,
    beforeEnter: isAuth,
    meta: {
      title: "Blog Management",
      menuGroup: "Website",
    },
  },
  {
    path: "/blog-editor/:blogId?",
    name: "blog-editor",
    component: BlogEditor,
    beforeEnter: isAuth,
    props: (route) => ({
      blogId: route.params.blogId,
    }),
    meta: {
      title: "Blog Editor",
      menuGroup: "Website",
    },
  },
  {
    path: "/ops-dashboard",
    name: "ops-dashboard",
    component: OpsDashboard,
    // beforeEnter: isAdminAuth,
    meta: {
      title: "Operations Dashboard",
      menuGroup: "Operations",
    },
  },
];

let flyRoutes = routes.map((i) => {
  let meta = i.meta || {};
  meta.isFly = true;
  return { ...i, meta };
});

export default flyRoutes;
